module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.11379/assets/images/solutions-marketplace.png"